import gql from "graphql-tag";

export const FETCH_CART_V2 = gql`
  query fetchCartV2($patientId: UUID!, $reminderId: UUID) {
    fetchCartV2(patientId: $patientId, reminderId: $reminderId) {
      message {
        showOnlyAtCart
        value
        feedback
      }
      nonCartTat {
        errorMessage
        tatHours
        tatHoursSlot
      }
      data {
        address {
          city
          coordinate {
            latitude
            longitude
          }
          id
          state
          zipcode
        }
        amount {
          standardPackingCharge
          packingFee
          hcBreakdown {
            availableNow
            balance
            message
            wallet
            effectiveAmount
          }
          platformFee {
            message
            discountedValue
            value
          }
          cartSavings
          cartTotal
          circleBenefitMessage
          circleCashBack
          circleSavings {
            membershipCashBack
            circleDelivery
            title {
              template
              attribute {
                amount
                symbol
              }
            }
            message {
              template
              attribute {
                amount
                symbol
              }
            }
            homeMessage {
              template
              attribute {
                amount
                symbol
              }
            }
          }
          couponCashBack
          couponSavings
          deliveryCharges
          estimatedAmount
          estimatedAmountPreCoupon
          freeDeliveryAmount
          isDeliveryFree
          standardDeliveryCharge
          totalCashBack
          effectiveAmount
          bankOfferCashBack
          bankOfferCoupon
          bankOfferDiscount
          bankOfferId
          isBankOfferApplied
          usedHC
          availableHC
          mov
        }
        cartBreakdown {
          amountBreakups {
            text
            style
            breakups {
              name {
                structure {
                  text
                  style
                }
                tooltip
                meta {
                  click_to_open
                }
              }
              value {
                meta {
                  click_to_open
                }
                structure {
                  text
                  style
                }
                tooltip
              }
            }
          }
          paymentBreakups {
            text
            style
            breakups {
              name {
                meta {
                  click_to_open
                }
                structure {
                  style
                  text
                }
                tooltip
              }
              value {
                meta {
                  click_to_open
                }
                structure {
                  style
                  text
                }
                tooltip
              }
            }
          }
        }
        couponDetails {
          bankOffer
          circleBenefits
          coupon
          message
          textOffer
          valid
        }
        isHCPreferred
        medicineOrderCartLineItems {
          corporateStatus
          cartSource
          cashback
          classifier_1
          classifier_2
          classifier_3
          isVCRestricted
          couponDiscountPrice
          freeProduct
          isCouponApplicable
          isExpress
          isInStock
          isPrescriptionRequired
          isShippable
          itemCouponCashback
          magentoId
          magentoStatus
          maxOrderQty
          mou
          name
          packForm
          packSize
          price
          quantity
          reminderDuration
          sellOnline
          moq
          sellingPrice
          setReminder
          shipmentNo
          sku
          storeType
          subcategory
          tat
          tatCity
          tatDuration
          thumbnail
          typeId
          urlKey
          isVariantAvailable
          multiVariants {
            attributes {
              label
              values {
                code
                label
              }
            }
            products {
              sku
              variant_key
              image
              small_image
              thumbnail
              name
              unit_of_measurement
              price
              exists
              special_price
              mrp
            }
          }
        }
        noOfShipments
        patientId
        prescriptionDetails {
          addedBy
          appointmentId
          documentId
          hashedDocumentId
          fileUrl
          meta {
            createdAt
            doctorName
            fileName
            fileType
            medicineNames
            medicineSku
            patientName
          }
          prismFileId
          uhid
        }
        proceedNudge {
          button1 {
            action
            text
          }
          button2 {
            action
            text
          }
          corporateIconToShow
          description
          disclaimer
          heading
        }
        reminderDetails {
          isFeatureEnabled
          isReminderSet
          isUserDenied
        }
        subscriptionDetails {
          circleAddedToCart
          planPurchaseDetails {
            currentSellingPrice
            durationInMonth
            planAmount
            planId
            subPlanId
            validDuration
          }
          subscriptionApplied
          userSubscriptionId
        }
        outOfStockItemsList
        coupon {
          enabled
          message
        }
        circle {
          enabled
        }
        healthCredits {
          enabled
          checkboxEnable
        }
        corporateProgram {
          available_hc
          enabled
          hc_qualified
          rejectionReason
          message
          unlimited
          copay {
            infoCard {
              description
            }
            value
          }
        }
        user {
          isCorporateProgram
          partnerId
        }
        nudge {
          bulletedList
          button1Text
          button2Text
          heading
          message
          note
        }
        nudges {
          bulletedList
          button1Text
          button2Text
          buttons {
            action
            text
            precedence
          }
          context
          heading
          message
          note
        }
        contactNumber
        showVCRestrictedPopUp
      }
    }
  }
`;

export const SAVE_CART_V2 = gql`
  mutation saveCartV2($cartInputDataV2: CartInputDataV2!) {
    saveCartV2(cartInputV2: $cartInputDataV2) {
      message {
        showOnlyAtCart
        value
        feedback
      }
      nonCartTat {
        errorMessage
        tatHours
        tatHoursSlot
      }
      data {
        showVCRestrictedPopUp
        address {
          city
          coordinate {
            latitude
            longitude
          }
          id
          state
          zipcode
        }
        amount {
          standardPackingCharge
          packingFee
          hcBreakdown {
            availableNow
            balance
            message
            wallet
            effectiveAmount
          }
          platformFee {
            message
            discountedValue
            value
          }
          cartSavings
          cartTotal
          circleBenefitMessage
          circleCashBack
          circleSavings {
            membershipCashBack
            circleDelivery
            title {
              template
              attribute {
                amount
                symbol
              }
            }
            message {
              template
              attribute {
                amount
                symbol
              }
            }
            homeMessage {
              template
              attribute {
                amount
                symbol
              }
            }
          }
          couponCashBack
          couponSavings
          deliveryCharges
          estimatedAmount
          estimatedAmountPreCoupon
          freeDeliveryAmount
          isDeliveryFree
          standardDeliveryCharge
          totalCashBack
          effectiveAmount
          bankOfferCashBack
          bankOfferCoupon
          bankOfferDiscount
          bankOfferId
          isBankOfferApplied
          usedHC
          availableHC
          mov
        }
        cartBreakdown {
          amountBreakups {
            text
            style
            breakups {
              name {
                structure {
                  text
                  style
                }
                tooltip
                meta {
                  click_to_open
                }
              }
              value {
                meta {
                  click_to_open
                }
                structure {
                  text
                  style
                }
                tooltip
              }
            }
          }
          paymentBreakups {
            text
            style
            breakups {
              name {
                meta {
                  click_to_open
                }
                structure {
                  style
                  text
                }
                tooltip
              }
              value {
                meta {
                  click_to_open
                }
                structure {
                  style
                  text
                }
                tooltip
              }
            }
          }
        }
        couponDetails {
          bankOffer
          circleBenefits
          coupon
          message
          textOffer
          valid
        }
        isHCPreferred
        medicineOrderCartLineItems {
          corporateStatus
          cartSource
          cashback
          classifier_1
          classifier_2
          classifier_3
          couponDiscountPrice
          freeProduct
          isCouponApplicable
          isExpress
          isInStock
          isPrescriptionRequired
          isVCRestricted
          isShippable
          itemCouponCashback
          magentoId
          magentoStatus
          maxOrderQty
          mou
          name
          packForm
          packSize
          price
          quantity
          reminderDuration
          sellOnline
          sellingPrice
          setReminder
          shipmentNo
          sku
          storeType
          subcategory
          tat
          tatCity
          tatDuration
          thumbnail
          moq
          typeId
          urlKey
          isVariantAvailable
          multiVariants {
            attributes {
              label
              values {
                code
                label
              }
            }
            products {
              sku
              variant_key
              image
              small_image
              thumbnail
              name
              unit_of_measurement
              price
              exists
              special_price
              mrp
            }
          }
        }
        noOfShipments
        patientId
        prescriptionDetails {
          addedBy
          appointmentId
          documentId
          hashedDocumentId
          fileUrl
          meta {
            createdAt
            doctorName
            fileName
            fileType
            medicineNames
            medicineSku
            patientName
          }
          prismFileId
          uhid
        }
        proceedNudge {
          button1 {
            action
            text
          }
          button2 {
            action
            text
          }
          corporateIconToShow
          description
          disclaimer
          heading
        }
        reminderDetails {
          isFeatureEnabled
          isReminderSet
          isUserDenied
        }
        subscriptionDetails {
          circleAddedToCart
          planPurchaseDetails {
            currentSellingPrice
            durationInMonth
            planAmount
            planId
            subPlanId
            validDuration
          }
          subscriptionApplied
          userSubscriptionId
        }
        outOfStockItemsList
        coupon {
          enabled
          message
        }
        circle {
          enabled
        }
        healthCredits {
          enabled
          checkboxEnable
        }
        corporateProgram {
          available_hc
          enabled
          hc_qualified
          rejectionReason
          message
          unlimited
          copay {
            infoCard {
              description
            }
            value
          }
        }
        user {
          isCorporateProgram
          partnerId
        }
        nudge {
          bulletedList
          button1Text
          button2Text
          heading
          message
          note
        }
        nudges {
          bulletedList
          button1Text
          button2Text
          buttons {
            action
            text
            precedence
          }
          context
          heading
          message
          note
        }
        contactNumber
      }
    }
  }
`;

export const REVIEW_CART_V2 = gql`
  query reviewCartV2($optionType: DeliveryOptions, $patientId: UUID!) {
    reviewCartV2(optionType: $optionType, patientId: $patientId) {
      message {
        showOnlyAtCart
        value
        feedback
      }
      nonCartTat {
        errorMessage
        tatHours
        tatHoursSlot
      }
      data {
        showVCRestrictedPopUp
        address {
          city
          coordinate {
            latitude
            longitude
          }
          id
          state
          zipcode
        }
        amount {
          standardPackingCharge
          packingFee
          hcBreakdown {
            availableNow
            balance
            message
            wallet
            effectiveAmount
          }
          platformFee {
            message
            discountedValue
            value
          }
          cartSavings
          cartTotal
          circleBenefitMessage
          circleCashBack
          circleSavings {
            membershipCashBack
            circleDelivery
            title {
              template
              attribute {
                amount
                symbol
              }
            }
            message {
              template
              attribute {
                amount
                symbol
              }
            }
            homeMessage {
              template
              attribute {
                amount
                symbol
              }
            }
          }
          couponCashBack
          couponSavings
          deliveryCharges
          estimatedAmount
          estimatedAmountPreCoupon
          freeDeliveryAmount
          isDeliveryFree
          standardDeliveryCharge
          totalCashBack
          effectiveAmount
          bankOfferCashBack
          bankOfferCoupon
          bankOfferDiscount
          bankOfferId
          isBankOfferApplied
          usedHC
          availableHC
          mov
        }
        cartBreakdown {
          amountBreakups {
            text
            style
            breakups {
              name {
                structure {
                  text
                  style
                }
                tooltip
                meta {
                  click_to_open
                }
              }
              value {
                tooltip
                meta {
                  click_to_open
                }
                structure {
                  text
                  style
                }
              }
            }
          }
          paymentBreakups {
            text
            style
            breakups {
              name {
                meta {
                  click_to_open
                }
                structure {
                  style
                  text
                }
                tooltip
              }
              value {
                meta {
                  click_to_open
                }
                structure {
                  style
                  text
                }
                tooltip
              }
            }
          }
        }
        couponDetails {
          bankOffer
          circleBenefits
          coupon
          message
          textOffer
          valid
        }
        isHCPreferred
        medicineOrderCartLineItems {
          corporateStatus
          cartSource
          cashback
          couponDiscountPrice
          isVCRestricted
          freeProduct
          isCouponApplicable
          isExpress
          isInStock
          isPrescriptionRequired
          isShippable
          itemCouponCashback
          magentoId
          magentoStatus
          maxOrderQty
          mou
          name
          moq
          packForm
          packSize
          price
          quantity
          reminderDuration
          sellOnline
          moq
          sellingPrice
          setReminder
          shipmentNo
          sku
          storeType
          subcategory
          tat
          tatCity
          tatDuration
          thumbnail
          typeId
          urlKey
          isVariantAvailable
          multiVariants {
            attributes {
              label
              values {
                code
                label
              }
            }
            products {
              sku
              variant_key
              image
              small_image
              thumbnail
              name
              unit_of_measurement
              price
              exists
              special_price
              mrp
            }
          }
        }
        noOfShipments
        patientId
        prescriptionDetails {
          addedBy
          appointmentId
          documentId
          hashedDocumentId
          fileUrl
          meta {
            createdAt
            doctorName
            fileName
            fileType
            medicineNames
            medicineSku
            patientName
          }
          prismFileId
          uhid
        }
        proceedNudge {
          button1 {
            action
            text
          }
          button2 {
            action
            text
          }
          corporateIconToShow
          description
          disclaimer
          heading
        }
        reminderDetails {
          isFeatureEnabled
          isReminderSet
          isUserDenied
        }
        subscriptionDetails {
          circleAddedToCart
          planPurchaseDetails {
            currentSellingPrice
            durationInMonth
            planAmount
            planId
            subPlanId
            validDuration
          }
          subscriptionApplied
          userSubscriptionId
        }
        outOfStockItemsList
        coupon {
          enabled
          message
        }
        circle {
          enabled
        }
        healthCredits {
          enabled
          checkboxEnable
        }
        corporateProgram {
          available_hc
          enabled
          hc_qualified
          rejectionReason
          message
          unlimited
          copay {
            infoCard {
              description
            }
            value
          }
        }
        user {
          isCorporateProgram
          partnerId
        }
        nudge {
          bulletedList
          button1Text
          button2Text
          heading
          message
          note
        }
        nudges {
          bulletedList
          button1Text
          button2Text
          buttons {
            action
            text
            precedence
          }
          context
          heading
          message
          note
        }
      }
    }
  }
`;

export const SAVE_MEDICINE_ORDER_V4 = gql`
  mutation saveMedicineOrderV4($medicineOrderInput: SaveMedicineOrderV4Input) {
    saveMedicineOrderV4(medicineOrderInput: $medicineOrderInput) {
      status
      refreshCart
      message {
        value
      }
      data {
        transactionId
        orders {
          id
          orderAutoId
          estimatedAmount
        }
        substitutionAttrs {
          isSubstitution
          substitutionTime
          substitutionMessage
        }
        paymentAttrs {
          isCodEligible
          codMessage
          paymentOrderId
        }
      }
    }
  }
`;

export const GET_PHARMA_CART_DETAILS = gql`
  query getPharmaCartDetails($patientId: String!) {
    getPharmaCartDetails(patientId: $patientId) {
      groupCards {
        precedence
        shipmentDetails {
          deliveryMessage
          tatInText
          tat
          isShippable
          type
        }
        products {
          precedence
          sku {
            id
            sku
            name
            qtyInCart
            thumbnail
            isPrescriptionRequired
            isVCRestricted
            isSampling
            moq
            manufacturer
            variant
            packInformation
          }
          qtyDropdown {
            nudge {
              heading
              message
              context
              disclaimer
              bulletedList
              buttons {
                text
                action
                precedence
              }
            }
            quantities {
              qty
              isSelected
              bmsmDiscount
              isNudgeToBeShown
            }
          }
          discountInfo {
            mrp
            price
            discountInPercent
          }
          tag {
            name
            text
            tooltip
          }
          flags {
            freebie
          }
          corporate {
            status
            creditsQualified
            tooltip
          }
          bmsmDetails {
            message
            tiers {
              precedence
              quantity
              discountInPercent
            }
          }
          options {
            isAlternative
            isMultiVariants
            isSubstitute
            isReplacementProducts
            multiVariantsAttributes {
              label
              values {
                code
                label
              }
            }
            products {
              id
              name
              qtyInCart
              price
              mrp
              discountInPercent
              thumbnail
              isPrescriptionRequired
              isVCRestricted
              isSampling
              moq
              manufacturer
              variant
              sku
              tag {
                name
                value
              }
            }
          }
        }
      }
    }
  }
`;
